import { Link } from "react-router-dom";

/**
 * Two rendering modes:
 *  - Default (light backgrounds): full-color PNG logo.
 *  - Inverse (dark backgrounds like the footer): CSS wordmark so we avoid the
 *    blocky silhouette that the CSS invert filter produces on the color PNG.
 */
export default function BrandLogo({ inverse = false, className = "" }) {
  if (inverse) {
    return (
      <Link
        to="/"
        data-testid="header-logo"
        className={`inline-flex items-baseline gap-0 select-none ${className}`}
        aria-label="ZaranTech home"
      >
        <span
          className="font-display font-bold tracking-tight text-2xl"
          style={{ color: "#ffffff" }}
        >
          Zaran
        </span>
        <span
          className="font-display font-bold tracking-tight text-2xl"
          style={{ color: "var(--cyan)" }}
        >
          Tech
        </span>
      </Link>
    );
  }

  return (
    <Link
      to="/"
      data-testid="header-logo"
      className={`inline-flex items-center ${className}`}
      aria-label="ZaranTech home"
    >
      <img
        src="/brand/zarantech-logo.png"
        alt="ZaranTech"
        width="180"
        height="36"
        fetchPriority="high"
        decoding="async"
        className="h-9 w-auto max-w-[180px] object-contain"
      />
    </Link>
  );
}
